import 'core-js/stable';
import 'intl-pluralrules';
import 'error-polyfill';
import '@formatjs/intl-relativetimeformat/polyfill';

if (typeof Number.isFinite !== 'function') {
  Number.isFinite = function isFinite(value) {
    if (typeof value !== 'number') {
      return false;
    }

    /* eslint-disable no-self-compare */
    if (value !== value || value === Infinity || value === -Infinity) {
      /* eslint-enable */
      return false;
    }

    return true;
  };
}
